import React from "react";
import { Button, createStyles, darken, Grid, Theme, Typography } from "@material-ui/core";
import styled from "styled-components";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { blue, green } from "@material-ui/core/colors";
import { AccountDepositDefinition } from "../../models/AccountDepositDefinition";

interface IProps {
  ticket: AccountDepositDefinition;
  onBtnClick: (ticket: AccountDepositDefinition | null) => void;
  isSelect: boolean;
}

const TicketButton = styled(Button)`
  display: inline;
  width: 100%;
  border: "1px solid #fff";
  margin-bottom: 5px;
`;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    primary: {
      backgroundColor: blue[600],
      color: theme.palette.getContrastText(blue[600]),
      "&:hover": {
        backgroundColor: darken(blue[600], 0.1),
      },
    },
    handle: {
      backgroundColor: blue[300],
      color: theme.palette.getContrastText(blue[300]),
      "&:hover": {
        backgroundColor: darken(blue[300], 0.1),
      },
    },
    select: {
      backgroundColor: green[300],
      color: theme.palette.getContrastText(green[300]),
      "&:hover": {
        backgroundColor: darken(green[300], 0.1),
      },
    },
  })
);

const AccDefinitionBtnSet: React.FC<IProps> = ({ ticket, onBtnClick, isSelect }: IProps) => {
  const classes = useStyles();

  const sumDepositAmmount = () =>
    ticket.accountAmountI + ticket.accountAmountII + ticket.accountAmountIII + ticket.accountDeposit;

  return (
    <TicketButton
      variant={"contained"}
      className={isSelect ? classes.select : classes.primary}
      onClick={() => (isSelect ? onBtnClick(null) : onBtnClick(ticket))}
    >
      <Grid container alignItems={"center"}>
        <Grid item xs={6}>
          <Typography variant={"button"} display={"block"}>
            {ticket.description}
          </Typography>
        </Grid>
        <Grid item xs={6} className={classes.handle}>
          <Typography variant={"caption"} display={"block"} style={{ margin: 0 }}>
            {isSelect ? "Wybrano" : "Wybierz"}
          </Typography>
          <Typography variant={"caption"} display={"block"} style={{ margin: 0 }}>
            {`${sumDepositAmmount()} zł`}
          </Typography>
        </Grid>
      </Grid>
    </TicketButton>
  );
};

export default AccDefinitionBtnSet;
